/** 9-Block 셀 제목 */
export function getBlockTitle(perf: string, behav: string): string {
  if (perf === 'EX' && behav === 'EX') return '고성과 인재';
  if (perf === 'EX' && behav === 'GD') return '우수 인재 (일하는 방식 코칭)';
  if (perf === 'EX' && behav === 'NI') return '집중 육성 대상 (일하는 방식 비대칭)';
  if (perf === 'GD' && behav === 'EX') return '우수 인재 (성과 코칭)';
  if (perf === 'GD' && behav === 'GD') return '보통 성과자';
  if (perf === 'GD' && behav === 'NI') return '집중 육성 대상 (일하는 방식)';
  if (perf === 'NI' && behav === 'EX') return '집중 육성 대상 (성과 비대칭)';
  if (perf === 'NI' && behav === 'GD') return '집중 육성 대상 (성과 창출)';
  return '한계 인력';
}

export type RatingResult = {
  rating: 'EXCELLENT' | 'GOOD' | 'POOR';
  score: number;
  label: string;
};

export function calculateQuantitativeRating(rate: number): RatingResult {
  if (rate > 100) return { rating: 'EXCELLENT', score: 110, label: '훌륭해요' };
  if (rate >= 85) return { rating: 'GOOD', score: 90, label: '준수해요' };
  return { rating: 'POOR', score: 80, label: '노력해요' };
}

export function calculateQualitativeRating(checks: Record<string, boolean>): RatingResult {
  const checkCount = Object.values(checks).filter(Boolean).length;
  if (checkCount >= 3) return { rating: 'EXCELLENT', score: 110, label: '훌륭해요' };
  if (checkCount === 2) return { rating: 'GOOD', score: 90, label: '준수해요' };
  return { rating: 'POOR', score: 80, label: '노력해요' };
}
